export const en = {
  title: 'Link Relationships Account',
  subtitle: 'Please enter your Relationships account login information below',
}

export const es = en
